import { Component, OnInit } from '@angular/core';
import { HighlightService } from 'src/app/@core/services/highligh.service';

@Component({
  selector: 'app-footer-doc',
  templateUrl: './footer-doc.component.html',
  styleUrls: ['./footer-doc.component.scss']
})
export class FooterDocComponent implements OnInit {

  utils: any;
  highlighted: boolean = false;
  codeHtml: string;
  codeJs: string;
  infoComponent: { titulo: string; descripcion: string; };
  constructor(
    private highlightService: HighlightService) {
    this.utils = window.utils;
    this.codeHtml = `
    <footer>
      <div class="footer page__footer footer-white footer-blue">
      <div class="container">
        <div class="footer-container" id="footer-container">
          <div class="footer-title d-flex  bd-highlight">
            <h2 class="title-footer">Contáctanos</h2>
          </div>
          <div
            class="nav-footer icon-white  nav-pills nav-pills-icons icon-white d-flex justify-content-center bd-highlight">
            <div class="item-footer">
              <a class="nav-link icon-white" onClick="utils.viewportLink('/#')">              
                <span class="govco-icon govco-icon-callin-cn"></span>
                <p class="title-contact-link">Llamada WEB </p>
                <p class="content-link">
                  Solicitar llamada
                </p>
              </a>
            </div>
            <div class="item-footer">
              <a class="nav-link icon-white" target="_blank" href="mailto:soporteccc@mintic.gov.co">                
                <span class="govco-icon govco-icon-email-cn"></span>
                <p class="title-contact-link"> Correo electrónico </p>
                <p class="content-link">
                  soporteccc@mintic.gov.co
                </p>
              </a>
            </div>
            <div class="item-footer">
              <div class="nav-link icon-white" >
                <span class="govco-icon govco-icon-call-center-cn"></span>
                <p class="title-contact-link"> Contacto telefónico </p>
                <p class="content-link">
                  <br class="d-sm-block d-md-none notranslate"/>
                  <a class="notranslate" href="tel:01 8000 910742">Nacional: 01 8000 910742</a>
                  <br class="d-sm-block d-md-none d-md-block notranslate"/>
                  <a class="notranslate" href="tel:031 390 7951">Bogotá: 57 390 7951</a>
                </p>
              </div>
            </div>
            <div class="item-footer">
              <a class="nav-link icon-white" href="utils.getServerWebUrl('/#')" >
                <span class="govco-icon govco-icon-wifi-cn"></span>
                <p class="title-contact-link"> Redes sociales </p>
                <p class="content-link">
                  de las entidades
                </p>
              </a>
            </div>
            <div class="item-footer">
              <a class="nav-link icon-white" onClick="utils.viewportLink('/#')">   
                <span class="govco-icon govco-icon-callback-cn"></span>
                <p class="title-contact-link"> Regresamos tu llamada </p>
                <p class="content-link">
                  al número que nos indiques
                </p>
              </a>
            </div>
          </div>
          <div class="submenu-footer d-flex justify-content-center bd-highlight">
            <ul class="pl-sm-0">
              <li>
                  <a href="utils.getServerWebUrl('/#')">
                  Sobre nosotros
                </a>
              </li>
              <li>
                  <a href="utils.getServerWebUrl('/#')">
                  Términos de uso
                </a>
              </li>
              <li>
                <a href="utils.getServerWebUrl('/#')">
                  Mapa del sitio
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      </div>
  </footer>
`;

    this.infoComponent = {
			titulo: 'Footer',
			descripcion:
				'El componente Footer, hace parte de los componentes maestros este componente debe contener siempre el el logo de GOV.CO.'
    }
  }

  ngAfterViewChecked() {
    if (!this.highlighted) {
      this.highlightService.highlightAll();
      this.highlighted = true;
    }
  }

  ngOnInit() {
    this.utils.init();
  }

}
